import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';
import AddBalanceForm from 'components/pages/Payments/AddBalanceForm';
import { useModalContext } from 'components/system/ModalContext';

const styles = {
  container: {
    minHeight: '165px',
    textAlign: 'center',
  },
};

const NotEnoughFunds = ({
  title, greeting, message, buttonLabel, onButtonClick, card,
}) => {
  const { closeModal } = useModalContext();

  return (
    <Box style={styles.container}>
      <Box style={{ padding: '15px 20px' }}>
        <Typography variant="h4" style={{ marginBottom: '28px', color: colors.text.primary }}>
          {title}
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: '16px' }}>
          {greeting}
        </Typography>
        <Typography variant="subtitle1" style={{ marginBottom: '28px' }}>
          {message}
        </Typography>
        {!card ? (
          <Button
            type="primary"
            variant="contained"
            onClick={onButtonClick}
          >
            {buttonLabel}
          </Button>
        )
          : <AddBalanceForm onBalanceUpdate={closeModal} withLabel={false} />}
      </Box>
    </Box>
  );
};

export default NotEnoughFunds;
